import Vue from 'vue'
import Router from 'vue-router'

import Full from '@/containers/Full'
import Hello from '@/components/Hello'
import Familylist from '@/components/Family_list'
import EditFamily from '@/components/EditFamily'
import Incomelist from '@/components/Income_list'
import users from '@/components/Manage'
import Adduser from '@/components/AddUser'
import Login from '@/components/Login'
import page404 from '@/components/Error_page'
import Backup from '@/components/Backup'
import DebtAnalyze from '@/components/Debt_Analyze'
import Expenditureanalyze from '@/components/Expenditure_analyze'
import Incomeanalyze from '@/components/Income_analyze'
import Incomecompare from '@/components/Income_compare'
import Incomereport from '@/components/Income_report'
import Setting from '@/components/Setting'
import Addfamily from '@/components/Add_family'
import Updateuser from '@/components/Updateuser'
import Addincome from '@/components/Add_income'
import Profile from '@/components/profile'

Vue.use(Router)

const titlename = ' | ระบบจัดเก็บข้อมูลบ้านแม่ขี้มูก'
const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  base: __dirname,
  routes: [
    {
      path: '/',
      redirect: '/',
      name: 'main',
      component: Full,
      children: [{
        path: '/',
        name: 'home',
        component: Hello,
        meta: { title: 'หน้าแรก' }
      },
      {
        path: '/users',
        name: 'users',
        component: users,
        meta: { title: 'จัดการสิทธิผู้ใช้งานระบบ' }
      },
      {
        path: '/updateuser/:id',
        name: 'Updateuser',
        component: Updateuser,
        meta: { title: 'แก้ไขข้อมูลผู้ใช้งานระบบ' }
      },
      {
        path: '/adduser',
        name: 'add_user',
        component: Adduser,
        meta: { title: 'เพิ่มผู้ใช้งานระบบ' }
      },
      {
        path: '/family_list',
        name: 'family_list',
        component: Familylist,
        meta: { title: 'จัดการครัวเรือน' }
      },
      {
        path: '/income_list',
        name: 'income_list',
        component: Incomelist,
        meta: { title: 'จัดเก็บข้อมูลรายได้' }
      },
      {
        path: '/Backup',
        name: 'backup',
        component: Backup,
        meta: { title: 'สำรองข้อมูล' }
      },
      {
        path: '/debt_analyze',
        name: 'debt_analyze',
        component: DebtAnalyze,
        meta: { title: 'ข้อมูลวิเคราะห์แนวโน้มหนี้สิน' }
      },
      {
        path: '/expenditure_analyze',
        name: 'expenditure_analyze',
        component: Expenditureanalyze,
        meta: { title: 'ข้อมูลวิเคราะห์แนวโน้มรายจ่าย' }
      },
      {
        path: '/income_analyze',
        name: 'income_analyze',
        component: Incomeanalyze,
        meta: { title: 'ข้อมูลวิเคราะห์แนวโน้มรายรับ' }
      },
      {
        path: '/income_compare',
        name: 'income_compare',
        component: Incomecompare,
        meta: { title: 'ข้อมูลเปรียบเทียบรายได้ครัวเรือน' }
      },
      {
        path: '/income_report',
        name: 'income_report',
        component: Incomereport,
        meta: { title: 'ข้อมูลรายได้ครัวเรือน' }
      },
      {
        path: '/setting',
        name: 'setting',
        component: Setting,
        meta: { title: 'จัดการข้อมูลระบบ' }
      },
      {
        path: '/add_family',
        name: 'add_family',
        component: Addfamily,
        meta: { title: 'เพิ่มข้อมูลครัวเรือน' }
      },
      {
        path: '/add_income',
        name: 'add_income',
        component: Addincome,
        meta: { title: 'เพิ่มข้อมูลรายได้' }
      },
      {
        path: '/edit_family/:id',
        name: 'edit_family',
        component: EditFamily,
        meta: { title: 'แก้ไขข้อมูลครัวเรือน' }
      },
      {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta: { title: 'ข้อมูลผู้ใช้งานระบบ' }
      }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { title: 'เข้าสู่ระบบ' }
    },
    {
      path: '*',
      name: 'P404',
      component: page404,
      meta: { title: 'Error Page' }
    }
  ]
})

const DEFAULT_TITLE = titlename
router.afterEach((to, from) => {
  document.title = to.meta.title + titlename || DEFAULT_TITLE + titlename
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js